<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'SEARCH.SEND-EMAIL' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div>
    <label for="email">{{'SEARCH.FILL-EMAIL' | translate}}:</label>
    <input class="form-control" type="text" id="email" [(ngModel)]="email">
  </div>
  <div class="m-t-15">
    <label for="broker-email">{{'SEARCH.FILL-BROKER-EMAIL' | translate}}:</label>
    <input class="form-control" type="text" id="broker-email" [(ngModel)]="brokerEmail">
  </div>

  <div *ngIf="resMessage" class="text-center">
    <b style="color:#ff002c;" *ngIf="!isSuccess">
      <div>{{ resMessage }}</div>
      <div>{{'SEARCH.EMAIL-ERROR' | translate}}</div>
    </b>
    <b *ngIf="isSuccess">
      <div>{{ resMessage }}</div>
    </b>
  </div>
</div>

<div class="modal-footer">
  <div class="col-6 text-left">
    <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="activeModal.close()">
      {{'SEARCH.CANCEL' | translate}}
    </button>
  </div>
  <div class="col-6 text-right p-0">
    <button type="button" *ngIf="!isSuccess || !resMessage" class="btn btn-dv btn-wide" [disabled]="isSending"
      (click)="sendMail()">
      <i *ngIf="isSending" class="fa fa-spinner fa-spin m-r-5"></i>
      {{ isSending ? ('SEARCH.SENDING' | translate) : ('SEARCH.SEND' | translate) }}
    </button>

    <button *ngIf="isSuccess && resMessage" type="button" class="btn btn-dv btn-wide" (click)="activeModal.close()">
      {{'COMMON.OK' | translate}}
    </button>
  </div>
</div>


// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/sendEmailModal/send-email-modal.component.html